import * as stylex from '@stylexjs/stylex';


const MEDIA_MOBILE = '@media (max-width: 768px)';

export const footerStyles = stylex.create({
    footer: {
        backgroundColor: 'var(--bg-card)',
        boxShadow: 'var(--shadow-sm)',
        paddingTop: '2rem',
        paddingInline: 0,
        paddingBottom: '1.5rem',
        marginTop: 'auto',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'var(--border)',
    },
    footerContent: {
        maxWidth: '1200px',
        marginInline: 'auto',
        paddingInline: '1rem',
        display: 'grid',
        gridTemplateColumns: {
            default: 'repeat(auto-fit, minmax(250px, 1fr))',
            [MEDIA_MOBILE]: '1fr',
        },
        gap: {
            default: '2rem',
            [MEDIA_MOBILE]: '1.5rem',
        },
    },
    footerSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
    },
    footerTitle: {
        fontSize: 'var(--font-size-md)',
        fontWeight: 600,
        color: 'var(--text-primary)',
        marginBottom: '0.5rem',
    },
    footerLink: {
        color: {
            default: 'var(--text-secondary)',
            ':hover': 'var(--primary)',
        },
        textDecoration: 'none',
        fontSize: 'var(--font-size-sm)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
    },
    socialLinks: {
        display: 'flex',
        gap: '1rem',
        marginTop: '0.5rem',
    },
    socialIcon: {
        color: {
            default: 'var(--text-secondary)',
            ':hover': 'var(--primary)',
        },
        borderRadius: 'var(--radius-full)',
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
        transform: {
            default: 'none',
            ':hover': 'translateY(-2px)',
        },
        filter: {
            default: 'none',
            ':hover': 'drop-shadow(0 0 3px var(--primary-light))',
        },
    },
    logoSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    footerLogo: {
        fontSize: 'var(--font-size-lg)',
        fontWeight: 'bold',
        color: {
            default: 'var(--text-primary)',
            ':hover': 'hsl(var(--hue-primary), 85%, 70%);',
        },
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
    },
    logoAccent: {
        backgroundImage: 'linear-gradient(90deg, var(--primary), var(--accent))',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
    },
    footerBottom: {
        maxWidth: '1200px',
        marginTop: '2rem',
        marginInline: 'auto',
        marginBottom: 0,
        paddingTop: '1.5rem',
        paddingInline: '1rem',
        paddingBottom: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'var(--border)',
        fontSize: 'var(--font-size-xs)',
        color: 'var(--text-secondary)',
        flexDirection: {
            default: 'row',
            [MEDIA_MOBILE]: 'column',
        },
        textAlign: {
            default: 'inherit',
            [MEDIA_MOBILE]: 'center',
        },
    },
    copyright: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    sparkle: {
        color: 'var(--accent)',
    },
});